import { useTranslation } from "react-i18next";
import { Text } from "@ucl/dse/text";
import { LinkButton } from "src/components/link-button/link-button";
import { LinkType } from "../../../types/general";
import { MedalliaSurvey } from "src/components/medallia-survey/medallia-survey";
import styles from "./declined-card.module.scss";

interface DeclinedCardProps {
    dealerConfig: LinkType;
    rangeConfig: LinkType;
}

export const DeclinedCard = ({ dealerConfig, rangeConfig }: DeclinedCardProps) => {
    const { t } = useTranslation();

    return (
        <>
            <div data-testid="resultsDeclinedCard">
                <Text.H1 fontWeight="semi-bold" data-testid="heading">
                    {t("creditDecision.declined.resultsHeader")}
                </Text.H1>
                <div className={styles.cardBody}>
                    <Text.P fontWeight="semi-bold" data-testid="subheading">
                        {t("creditDecision.declined.subHeading")}
                    </Text.P>
                    <Text.P data-testid="subheadingOtherOptions">
                        {t("creditDecision.declined.exploreOtherOptions")}
                    </Text.P>
                    <div className={styles.buttonGroup}>
                        <LinkButton
                            config={dealerConfig}
                            ariaLabel={
                                t("creditDecision.declined.speakToDealerButton") +
                                " " +
                                t("general.openNewTabAriaLabel")
                            }
                        >
                            {t("creditDecision.declined.speakToDealerButton")}
                        </LinkButton>
                        <LinkButton config={rangeConfig} variant="secondary">
                            {t("creditDecision.declined.exploreRangeButton")}
                        </LinkButton>
                    </div>
                </div>
            </div>
            <MedalliaSurvey />
        </>
    );
};
